import { digObject, generateRedirectUrl } from '@domain-group/javascript-utils'
import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useProviderPriceList from '@hooks/useProviderPriceList'

import { ProviderPriceListModel } from '@domain-group/realhub-backend-api-types'

const ProviderPriceListItem = (props: {providerPriceListItem: ProviderPriceListModel}) => {
  const { providerPriceListItem } = props

  const providerPriceListPayload = useProviderPriceList(providerPriceListItem)
  const {
    provider,
    providerPriceList,
    urls: { editProviderPriceListUrl },
  } = providerPriceListPayload

  const title = digObject(providerPriceList, 'title', '')
  const providerTitle = digObject(provider, 'title', '')

  return (
    <DashboardModuleListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {providerTitle}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}
export default ProviderPriceListItem
